<mat-dialog-content>
  <lemon-dialog-header>Tee luottokorttilaskusta kirjaukset</lemon-dialog-header>

  @if (lataa()) {
    <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px; margin-bottom: 20px"></mat-spinner>
  } @else {
    <form novalidate>
      <div style="max-width: 400px; margin-bottom: 10px">
        <mat-form-field>
          <mat-label>Maksutapa</mat-label>
          <mat-select [formField]="lomake.maksutapa" [compareWith]="vertaaMaksutapoja">
            @for (mt of maksutavatObservable | async; track mt.avain) {
              <mat-option [value]="mt">{{ mt.nimi }}</mat-option>
            }
          </mat-select>
          @if (onkoVirhe(lomake.maksutapa, 'required') && (lomake.maksutapa().dirty() || lomake.maksutapa().touched())) {
            <mat-error>Maksutapa puuttuu</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Velkatili</mat-label>
          <input type="text" tahtiOhjeeseen [formField]="lomake.velkatili" matInput [matAutocomplete]="velkatiliAutocomplete" placeholder="Velkatili" autocomplete="off" data-lpignore="true" />
          <mat-autocomplete #velkatiliAutocomplete="matAutocomplete" [panelWidth]="360" [displayWith]="displayVelkatili">
            @for (tili of suodatetutVelkatilitSubject | async; track tili.numero) {
              <mat-option [value]="tili">{{ tili.numero }} {{ tili.nimi }}</mat-option>
            }
          </mat-autocomplete>
          @if (onkoVirhe(lomake.velkatili, 'required') && (lomake.velkatili().dirty() || lomake.velkatili().touched())) {
            <mat-error>Velkatili puuttuu</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Prompti</mat-label>
          <mat-select [formField]="lomake.promptiId">
            @for (vaihtoehto of promptiVaihtoehdot(); track vaihtoehto.promptiId) {
              <mat-option [value]="vaihtoehto.promptiId">{{ vaihtoehto.nimi }}</mat-option>
            }
          </mat-select>
          @if (onkoVirhe(lomake.promptiId, 'required') && (lomake.promptiId().dirty() || lomake.promptiId().touched())) {
            <mat-error>Prompti puuttuu</mat-error>
          }
        </mat-form-field>

        @if (promptitOnTyhja()) {
          <div class="red-text" style="margin-top: 10px">Luottokorttilasku-promptia ei ole määritelty. Pyydä ylläpitäjää luomaan se LLM työkalut -näkymässä.</div>
        }

        @if (commonError()) {
          <div class="red-text" style="margin-top: 10px">{{ commonError() }}</div>
        }
      </div>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-secondary-button mat-dialog-close actionId="Tee luottokorttilaskusta kirjaukset: Peruuta">Peruuta</app-secondary-button>
  <app-primary-button (click)="luoKirjaukset()" actionId="Tee luottokorttilaskusta kirjaukset: Luo" [disabled]="lataa() || promptitOnTyhja()">Luo kirjaukset</app-primary-button>
</mat-dialog-actions>
